import React, {Component} from 'react'
import Radium from 'radium'
import FileDropZone from 'components/file-drop-zone'
import SymbolList from 'components/symbol-list'
import DownloadSVG from 'components/download-svg'
// import MissingSymbols from 'components/missing-symbols'

@Radium
export default class Tool extends Component {
  constructor () {
    super()
    this.state = {
      symbols: [],
      transforms: {
        removePrefix: '',
        removeSuffix: '',
        addPrefix: ''
      }
    }
  }

  onDrop = event => {
    const parser = new window.DOMParser()
    let _thisTool = this

    function loadFile (file) {
      let reader = new window.FileReader()
      reader.onload = readerOnLoad.bind(reader, file)
      reader.readAsText(file)

      function readerOnLoad (loadEvent) {
        let xmlhttp = new XMLHttpRequest() // eslint-disable-line no-undef
        xmlhttp.onreadystatechange = ajaxEvent => {
          if (xmlhttp.readyState === 4) {
            let resp = JSON.parse(xmlhttp.response)
            if (resp.data) {
              appendResult(resp.data)
            }
          }
        }
        xmlhttp.open('POST', '/svgo', true)
        xmlhttp.setRequestHeader('Content-Type', 'application/json;charset=UTF-8')
        xmlhttp.send(JSON.stringify({content: this.result}))
      }

      function appendResult (result) {
        let doc = parser.parseFromString(result, 'image/svg+xml')
        let shouldParseSymbols = doc.querySelectorAll('symbol').length > 0
        let symbolsToAppend = []

        if (shouldParseSymbols) {
          doc.querySelectorAll('symbol').forEach(symbol => {
            let title = symbol.querySelector('title')

            if (title) {
              symbol.removeChild(title)
            }

            let obj = {
              id: symbol.id,
              viewBox: symbol.getAttribute('viewBox'),
              content: symbol.innerHTML,
              bgString: '',
              include: true
            }

            let svgMarkup = `<svg viewBox='${obj.viewBox}' xmlns='http://www.w3.org/2000/svg' fill='#000'>${obj.content.replace('xmlns="http://www.w3.org/2000/svg"', '')}</svg>`
            obj.bgString = `background-image: url("data:image/svg+xml,${encodeURIComponent(svgMarkup)}");`

            symbolsToAppend.push(obj)
          })
        } else {
          let svgEl = doc.querySelector('svg')
          let fileName = file.name.toLowerCase() || ''

          if (fileName.substr(-4) === '.svg') {
            fileName = fileName.substr(0, fileName.length - 4)
          }

          let obj = {
            id: fileName,
            viewBox: svgEl.getAttribute('viewBox'),
            content: svgEl.innerHTML,
            bgString: '',
            include: true
          }

          let svgMarkup = `<svg viewBox='${obj.viewBox}' xmlns='http://www.w3.org/2000/svg' fill='#000'>${obj.content.replace('xmlns="http://www.w3.org/2000/svg"', '')}</svg>`
          obj.bgString = `background-image: url("data:image/svg+xml,${encodeURIComponent(svgMarkup)}");`

          symbolsToAppend.push(obj)
        }

        // Remove symbols without any content.
        symbolsToAppend = symbolsToAppend.filter(symbol => {
          return !!symbol.content
        })

        _thisTool.setState({
          symbols: _thisTool.state.symbols.concat(symbolsToAppend)
        })
      }
    }

    Array.from(event.dataTransfer.files).forEach(file => {
      loadFile(file)
    })
  }

  handleOnChange = (action, event) => {
    if (action in this.state.transforms) {
      this.setState({
        transforms: {
          ...this.state.transforms,
          [action]: event.target.value
        }
      })
    }
  }

  render () {
    return (
      <main style={styles.container}>
        <div style={styles.columnMain}>
          {this.state.symbols.length > 0 && <SymbolList symbols={this.state.symbols} />}
        </div>

        <div style={styles.columnAside}>
          <div style={styles.columnAsideInner}>
            <FileDropZone label='Släpp SVG-filer som innehåller ikoner eller en enskild ikon' onDrop={this.onDrop} />

            {this.state.symbols.length > 0 && <div>
              <div style={styles.fieldWrap}>
                <label style={styles.fieldLabel} htmlFor='remove-prefix-field'>Ta bort prefix</label>
                <input style={styles.fieldControl} id='remove-prefix-field' onChange={event => this.handleOnChange('removePrefix', event)} placeholder='lp- icons8-' />
                <p style={styles.fieldHelp}>Separera prefixer med kommatecken och/eller mellanslag.</p>
              </div>

              <div style={styles.fieldWrap}>
                <label style={styles.fieldLabel} htmlFor='remove-suffix-field'>Ta bort suffix</label>
                <input style={styles.fieldControl} id='remove-suffix-field' onChange={event => this.handleOnChange('removeSuffix', event)} placeholder='-50' />
                <p style={styles.fieldHelp}>Separera suffixer med kommatecken och/eller mellanslag.</p>
              </div>

              <div style={styles.fieldWrap}>
                <label style={styles.fieldLabel} htmlFor='add-prefix-field'>Lägg till prefix</label>
                <input style={styles.fieldControl} id='add-prefix-field' onChange={event => this.handleOnChange('addPrefix', event)} placeholder='lp-' />
                <p style={styles.fieldHelp}>Lägg till en prefix på <em>alla</em> ikoner. Har du exempelvis rensat bort <code style={styles.inlineCode}>lp-</code> kan du här lägga till den igen.</p>
              </div>

              <DownloadSVG symbols={this.state.symbols} transforms={this.state.transforms} />
            </div>}
          </div>
        </div>
      </main>
    )
  }
}

const styles = {
  container: {
    display: 'flex',
    maxWidth: '1600px',
    padding: '0 2rem',
    margin: '0 auto'
  },
  columnMain: {
    flex: '1',
    marginRight: '3rem'
  },
  columnAside: {
    position: 'relative',
    width: '25rem'
  },
  columnAsideInner: {
    position: 'fixed',
    width: 'inherit'
  },
  fieldWrap: {
    margin: '1.5rem 0'
  },
  fieldLabel: {
    display: 'block',
    marginBottom: '0.5rem',
    fontWeight: 700
  },
  fieldControl: {
    padding: '0.5rem 0.75rem',
    fontSize: '1em',
    fontWeight: 500,
    width: '100%',
    boxSizing: 'border-box',
    border: '2px solid #fff',
    borderRadius: '0.4em',
    backgroundColor: '#284842',
    color: '#fff'
  },
  fieldHelp: {
    fontSize: '0.9em',
    lineHeight: '1.4'
  },
  inlineCode: {
    padding: '0.2em 0.4em',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    display: 'inline-block',
    borderRadius: '0.2em'
  }
}



// WEBPACK FOOTER //
// src/components/tool/index.js